import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);

const AddTask = (props) => {
  const [loading, setLoading] = useState(true);
  const [task, setTask] = useState(
    props.mode === "edit" ? props.task.task : ""
  );
  const [date, setDate] = useState(
    props.mode === "edit" ? props.task.date : ""
  );
  const [user, setUser] = useState(props.user.id);
  const [note, setNote] = useState(
    props.mode === "edit" ? props.task.note : ""
  );
  const [edit, setEdit] = useState(props.mode === "edit" ? false : true);

  const getData = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const validate = () => {
    if (!task || !date) {
      return false;
    } else {
      return true;
    }
  };

  const fetchAddTask = async () => {
    var body = {
      task: task,
      date: date,
      note: note,
      user: props.user.id,
      id: props.lead.id,
    };

    await fetch("https://apisellcrm.ftpeople.pl/addTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zadanie",
          text: "dodane",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const addTask = () => {
    if (validate()) {
      fetchAddTask();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const fetchEditTask = async () => {
    var body = { id: props.task.id, task: task, date: date, note: note };

    await fetch("https://apisellcrm.ftpeople.pl/editTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zadanie",
          text: "zmienione",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const editTask = () => {
    if (validate()) {
      fetchEditTask();
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const handleDateChange = (e) => {
    if (new Date() > new Date(e.target.value)) {
      MySwal.fire({
        icon: "error",
        title: "Data zadania",
        text: "musi nastąpić w przyszłości",
      }).then(async (result) => {});
    } else {
      setDate(e.target.value);
    }
  };

  const fetchAcceptTask = async () => {
    var body = { id: props.task.id };

    await fetch("https://apisellcrm.ftpeople.pl/acceptTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zadanie",
          text: "wykonane",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const acceptTask = (e) => {
    fetchAcceptTask();
  };

  const fetchDeleteTask = async () => {
    var body = { id: props.task.id };

    await fetch("https://apisellcrm.ftpeople.pl/deleteTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Zadanie",
          text: "usunięte",
        }).then(async (result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const deleteTask = (e) => {
    fetchDeleteTask();
  };

  const endEditMode = (e) => {
    setEdit(false);
    setTask(props.task.task);
    setDate(props.task.date);
    setNote(props.task.note);
  };

  return (
    <>
      <div
        style={{
          width: "50vw",
          borderRadius: "15px",
          boxShadow: "-8px 0px 24px 0px rgba(66, 68, 90, 1)",
          position: "fixed",
          right: "0",
          top: "10vh",
          backgroundColor: "white",
          padding: "2%",
          margin: "0px 10px",
          zIndex: "2",
        }}
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                {edit ? (props.mode === "edit" ? "EDYTUJ" : "DODAJ") : ""}
                ZADANIE
                <br />
                <span style={{ fontSize: ".8vw" }}>
                  Użytkownik: {props.user.name}
                </span>
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={props.close}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px" }}>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  zadanie <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={task}
                  onChange={(e) => setTask(e.target.value)}
                />
              </div>
              <div style={{ width: "45%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  data <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  type="date"
                  style={{
                    width: "100%",
                    padding: "0px 10px",
                    boxSizing: "border-box",
                  }}
                  disabled={!edit}
                  value={date}
                  onChange={handleDateChange}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
              <div style={{ width: "99%", textAlign: "left" }}>
                <p
                  style={{
                    margin: "0",
                    marginBottom: "10px",
                    fontWeight: "600",
                    fontSize: ".8vw",
                    paddingLeft: "20px",
                  }}
                >
                  notatka
                </p>
                <textarea
                  type="text"
                  style={{
                    width: "100%",
                    padding: "10px 10px",
                    boxSizing: "border-box",
                    height: "20vh",
                    resize: "none",
                  }}
                  disabled={!edit}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>
            </div>
            <div
              style={{
                marginTop: "50px",
                display: "flex",
                gap: "20px",
              }}
            >
              {edit ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                    onClick={props.mode === "edit" ? editTask : addTask}
                  >
                    {props.mode === "edit" ? "EDYTUJ " : "DODAJ "} ZADANIE
                  </button>
                </>
              ) : (
                ""
              )}
              {props.mode === "edit" &&
              !edit &&
              props.task.status === "ZLECONE" &&
              (+props.task.user === +props.user.id ||
                props.user.role === "admin") ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "navy",
                      borderColor: "navy",
                    }}
                    onClick={() => setEdit(true)}
                  >
                    TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" &&
              edit &&
              props.task.status === "ZLECONE" &&
              (+props.task.user === +props.user.id ||
                props.user.role === "admin") ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={endEditMode}
                  >
                    ZAKOŃCZ TRYB EDYCJI
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" &&
              !edit &&
              props.task.status === "ZLECONE" &&
              (+props.task.user === +props.user.id ||
                props.user.role === "admin") ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                    }}
                    onClick={acceptTask}
                  >
                    OZNACZ JAKO WYKONANE
                  </button>
                </>
              ) : (
                ""
              )}

              {props.mode === "edit" &&
              props.task.status === "ZLECONE" &&
              (+props.task.user === +props.user.id ||
                props.user.role === "admin") ? (
                <>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "red",
                      borderColor: "red",
                    }}
                    onClick={deleteTask}
                  >
                    USUŃ
                  </button>
                </>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddTask;
